import { render, staticRenderFns } from "./RiskGroups.vue?vue&type=template&id=3465d254&scoped=true&"
import script from "./RiskGroups.vue?vue&type=script&lang=js&"
export * from "./RiskGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3465d254",
  null
  
)

export default component.exports